import React from 'react';

import { useHomePageSetsQuery } from '$/GraphQL/schema/schema';

import { getSortedPublishedSets } from '$/sections/Home/Dashboard/getPublishedSets';

import { useMeMaybe } from './useMe';

export const useAllSets = () => {
  const setsQuery = useHomePageSetsQuery({
    fetchPolicy: 'cache-only',
  });
  const sets = setsQuery.data?.homePageSets ?? [];
  return sets;
};

export const usePublishedSets = () => {
  const setsQuery = useHomePageSetsQuery({
    fetchPolicy: 'cache-only',
  });
  const sets = setsQuery.data?.homePageSets;
  const publishedSets = React.useMemo(() => getSortedPublishedSets(sets ?? []), [sets]);
  return publishedSets;
};

export const useAssignedSets = () => {
  const me = useMeMaybe();
  const publishedSets = usePublishedSets();
  const assignedSets = React.useMemo(
    () =>
      publishedSets.filter((set) => {
        return set.set.assignedModerators.some((mod) => mod.id === me?.id);
      }),
    [publishedSets, me?.id]
  );
  const publishedSetsIds = React.useMemo(() => publishedSets.map((set) => set.id), [publishedSets]);
  const assignedSetsIds = React.useMemo(() => assignedSets.map((set) => set.id), [assignedSets]);
  return { publishedSets, assignedSets, publishedSetsIds, assignedSetsIds };
};
